import type { ResolvedMonospacePage, Uuid } from '#layers/data-model/public';
import { useRouter } from '#app/composables/router';
import { useWorkspaceStore } from '#layers/workspace/public';

export function usePageNavigation() {
	const router = useRouter();
	const { currentWorkspaceSlug } = useWorkspaceStore();

	async function editPage(page: ResolvedMonospacePage | Uuid, options: { replace?: boolean; saveCurrentPath?: boolean } = {}) {
		const { replace = false, saveCurrentPath = false } = options;

		await router[replace ? 'replace' : 'push']({
			name: 'workspace-page-builder',
			params: {
				workspace: currentWorkspaceSlug.value!,
				pageId: typeof page === 'string' ? page : page.id,
			},
			query: saveCurrentPath ? { redirect: router.currentRoute.value.fullPath } : {},
		});
	}

	return {
		editPage,
	};
}
